import { IThunkActionCreator } from '../../index';
import { ISimilarOffersReceivedData, TModelType } from '../types';
import { ESimilarOffersActionType, ISimilarOffersReceivedAction } from './types';

export function similarOffersReceived(data: ISimilarOffersReceivedData, modelType: TModelType): IThunkActionCreator {
  // tslint:disable-next-line:variable-name
  return (dispatch, _getState, _context) => {
    const { offers, modelVersion, withoutCompetitors } = data;
    dispatch<ISimilarOffersReceivedAction>({
      type: ESimilarOffersActionType.ISimilarOffersReceived,
      list: offers,
      withoutCompetitors: withoutCompetitors || null,
      modelVersion: modelVersion || null,
      modelType,
    });
  };
}
